import axios from 'axios';
import toast from 'react-hot-toast';

// API Base URL - Sử dụng domain production
const API = 'https://admin.falppllc.com/api';
console.log('API Base URL:', API);

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  timeout: 30000, // Tăng timeout lên 30 giây
  withCredentials: true, // Cho phép gửi cookies và credentials
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Log request để debug
    console.log('🚀 API Request:', {
      method: config.method?.toUpperCase(),
      url: config.url,
      baseURL: config.baseURL,
      headers: config.headers
    });
    
    return config;
  },
  (error) => {
    console.error('❌ Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', {
      status: response.status,
      url: response.config.url,
      data: response.data
    });
    return response;
  },
  (error) => {
    // Handle different types of errors
    if (error.response) {
      // Server responded with error status
      console.error('❌ API Error Response:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
        url: error.config?.url
      });
      
      switch (error.response.status) {
        case 401:
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user');
          // Show login message and redirect to home page
          toast.error('Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.');
          setTimeout(() => {
            window.location.href = '/';
          }, 2000);
          break;
        case 403:
          console.error('Access forbidden');
          // Xử lý tài khoản bị từ chối hoặc đình chỉ
          if (error.response?.data?.message?.includes('từ chối') || 
              error.response?.data?.message?.includes('đình chỉ') ||
              error.response?.data?.message?.includes('Vai trò đã thay đổi')) {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('user');
            toast.error('Tài khoản của bạn đã bị hạn chế. Vui lòng liên hệ admin.');
            setTimeout(() => {
              window.location.href = '/login';
            }, 2000);
          } else {
            // Show login message and redirect to home page
            toast.error('Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.');
            setTimeout(() => {
              window.location.href = '/';
            }, 2000);
          }
          break;
        case 404:
          console.error('Resource not found');
          break;
        case 500:
          console.error('Server error:', error.response?.data);
          console.error('Error response status:', error.response?.status);
          console.error('Error response headers:', error.response?.headers);
          console.error('Full error object:', error);
          // Không logout cho lỗi 500, chỉ log lỗi
          break;
        default:
          console.error('API Error:', error.response.data);
      }
    } else if (error.request) {
      // Request was made but no response received
      console.error('❌ Network error - no response received');
      console.error('API URL being used:', API);
      console.error('Request details:', error.request);
      console.error('Error code:', error.code);
      console.error('Error message:', error.message);
      
      // Hiển thị thông báo lỗi cho user
      if (error.code === 'ECONNABORTED') {
        toast.error('Kết nối API bị timeout. Vui lòng thử lại sau.');
      } else {
        toast.error('Không thể kết nối đến server. Vui lòng kiểm tra kết nối mạng.');
      }
    } else {
      // Something else happened
      console.error('❌ Error:', error.message);
      toast.error('Đã xảy ra lỗi không xác định. Vui lòng thử lại.');
    }
    
    return Promise.reject(error);
  }
);

export default api; 
